import {
	Container,
	ContainerGutter,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { LogoBonoPosventa } from '../../../assets/logo-bono-posventa';

const HuchaLogoWrapper = styled.div`
	width: 100%;
	min-width: 200px;
	max-width: 275px;
`;

export const PopupBonoPosventaCardC1 = () => {
	return (
		<Container data-testid="popup-c1-container" gutter={ContainerGutter.static200} stretchContent wrap="always">
			<HuchaLogoWrapper>
				<LogoBonoPosventa />
			</HuchaLogoWrapper>
			<Text
				appearance={TokenTextAppearance.headline100}
				color={TokenTextColor.primary}
				textAlign={TextAlignment.left}
				bold
			>
				{'Gracias por dejarnos cuidar de ti y de tu coche. ¡Aquí tienes tu regalo de bienvenida!'}
			</Text>
		</Container>
	);
};
